import service from "services/service";

export const getCuentasService = () => (
  service("get", "v3/abonos/cuentas")
);

export const getCuentasComercioPadreService = () => (
  service("get", "v3/abonos/cuentas/padre")
);

export const createCuentaService = (data) => (
  service("post", "v3/abonos/cuentas", { data })
);

export const updateCuentaService = (id, data) => (
  service("patch", `v3/abonos/cuentas/${id}`, { data })
);

export const deleteCuentaService = (id) => (
  service("delete", `v3/abonos/cuentas/${id}`)
);

export const getAbonosService = (data) => (
  service("post", "v3/abonos", { data })
);
export const getNotificacionesAbonosService = (data) => (
  service("post", "v3/abonos/notificaciones", { data })
);

export const createAbonoService = (data) => (
  service("post", "v3/abono", {
    contentType: 'multipart/form-data',
    form: data
  })
);

export const aplicarAbonoService = (id) => (
  service("patch", `v3/abono/${id}/aplicar`)
);

export const descartarAbonoService = (id) => (
  service("patch", `v3/abono/${id}/descartar`)
);

export const downloadAbonosService = (filters) => (
  service("post", "v3/abonos/descargar", {
    responseType: "blob",
    data: { filters },
  })
);
